import _ from 'lodash';
import imagemap from '../resources/imagemap.json';
import imagemapS3 from '../resources/imagemapS3.json';
import systems_imagemap from '../resources/systems_imagemap.json';

const ENDPOINT_IMAGE_MAP = imagemap ? mapKeysToLowerCase(imagemap) : {};
const ENDPOINT_BASE_DIR = ENDPOINT_IMAGE_MAP['basepath'] || 'dist/images/endpoints/';

// new images are stored in S3 bucket - e.g. in QA in vyopta_ui_container /src/main/resources/application-qa.yml#lines-48 s3.bucket - needs to be in sync for every environment
const ENDPOINT_IMAGE_MAP_S3 = imagemapS3 ? mapKeysToLowerCase(imagemapS3.images) : {};
const ENDPOINT_BASE_DIR_S3 = 'assets/images/endpoints/';

const SYSTEM_IMAGE_MAP = systems_imagemap ? mapKeysToLowerCase(systems_imagemap) : {};
const SYSTEM_BASE_DIR = SYSTEM_IMAGE_MAP['basepath'] || 'dist/images/systems/';
const SYSTEM_DEFAULT_IMG = SYSTEM_IMAGE_MAP['default'] || '40x40-unknown.png';


function cleanModel(rawMod) {
    return rawMod.toLowerCase().replaceAll('-', '').replaceAll('_', '').replaceAll(' ', '');
}

function mapKeysToLowerCase(map) {
    let mappedObj = _.mapKeys(map, function(val, key) {
        return cleanModel(key);
    });
    return _.mapValues(mappedObj, (value) => {
        return _.isPlainObject(value) ? mapKeysToLowerCase(value) : value;
    });
}

export default {
    getImageUrl: function(mod, manuf) {
        mod = localStorage.getItem('test_model') || mod;
        manuf = localStorage.getItem('test_mfg') || manuf
        
        if (Object.keys(ENDPOINT_IMAGE_MAP).length === 0 || !mod) {
            return [];
        }
        
        let model = cleanModel(mod);
        let manufacturer = manuf ? manuf.toLowerCase() : '';
        
        // check and see if there is a mapping to a different manufacturer
        if (manufacturer && Object.keys(ENDPOINT_IMAGE_MAP_S3).length > 0 && ENDPOINT_IMAGE_MAP_S3[manufacturer]) {
            if (typeof ENDPOINT_IMAGE_MAP_S3[manufacturer] === 'string') { // normally an object
                manufacturer = ENDPOINT_IMAGE_MAP_S3[manufacturer];
            }
        }
        let results = [];
        function strip(...values) {
            return values.reduce((value, p) => {
                return _.startsWith(value, p) ? value.slice(p.length) : value;
            })
        }

        model = strip(model,'zr:', 'zp:', 'mtr:', 'realpresence', 'barco clickshare hub', manufacturer);

        // todo need to strip trailing from ThinkSmart

        // check and see if there is a mapping to a different model
        if (model && manufacturer && Object.keys(ENDPOINT_IMAGE_MAP_S3).length > 0 && ENDPOINT_IMAGE_MAP_S3[manufacturer] && ENDPOINT_IMAGE_MAP_S3[manufacturer][model]) {
            if (typeof ENDPOINT_IMAGE_MAP_S3[manufacturer][model] === 'string') { // normally an array
                model = cleanModel(ENDPOINT_IMAGE_MAP_S3[manufacturer][model]);
            }
        }


        if (model && manufacturer && Object.keys(ENDPOINT_IMAGE_MAP_S3).length > 0) {
            if (ENDPOINT_IMAGE_MAP_S3[manufacturer] && ENDPOINT_IMAGE_MAP_S3[manufacturer][model] && Array.isArray(ENDPOINT_IMAGE_MAP_S3[manufacturer][model])) {
                results.push(...ENDPOINT_IMAGE_MAP_S3[manufacturer][model].map(e => ENDPOINT_BASE_DIR_S3 + manufacturer + '/' +model + '/' + e));
            }
        }
        
        if (ENDPOINT_IMAGE_MAP[model]) {
            // If we have an exact match in the imageMap, use the exact match.
            // Otherwise, try to parse off any common manufacturer prefix
            results.push(ENDPOINT_BASE_DIR + ENDPOINT_IMAGE_MAP[model]); 
        } else {
            model = strip(model,'cisco', 'spark', 'webex', 'telepresence', 'polycom', 'hp poly', 'realpresence', 'tandberg codec', 'tandberg', 'poly', 'lifeSize');

            if (ENDPOINT_IMAGE_MAP[model]) {
                results.push(ENDPOINT_BASE_DIR + ENDPOINT_IMAGE_MAP[model]);
            }
            
        }

        // add manufacturer image first
        if (manufacturer && Object.keys(ENDPOINT_IMAGE_MAP_S3).length > 0 && ENDPOINT_IMAGE_MAP_S3[manufacturer] && ENDPOINT_IMAGE_MAP_S3[manufacturer]['logo']) {
            results.unshift(ENDPOINT_BASE_DIR_S3 + manufacturer + '/' + ENDPOINT_IMAGE_MAP_S3[manufacturer]['logo']);
        } else if (manufacturer && ENDPOINT_IMAGE_MAP[manufacturer]) {
            results.unshift(ENDPOINT_BASE_DIR + ENDPOINT_IMAGE_MAP[manufacturer]);
        }
        
        if (results.length > 0) {
            return results;
        }

        return [];

    },

    getSystemImageUrl: function(mod) {
        if (Object.keys(SYSTEM_IMAGE_MAP).length === 0 || !mod) {
            return SYSTEM_BASE_DIR + SYSTEM_DEFAULT_IMG;
        }

        let model = mod.toLowerCase();

        if (SYSTEM_IMAGE_MAP[model]) { return SYSTEM_BASE_DIR + SYSTEM_IMAGE_MAP[model]; }


        return SYSTEM_BASE_DIR + SYSTEM_DEFAULT_IMG;
    }
}
